import type { FC } from 'react'
import { useMemo } from 'react'
import { DeleteOutlined, SaveOutlined, SendOutlined } from '@ant-design/icons'
import { Popover } from 'antd'

import './calendarActions.scss'
import { BiEraser } from 'react-icons/bi'

interface CalendarActionsProps {
    sendCalendar: () => void
    saveCalendar: () => void
    clearCalendar: () => void
    deleteCalendar: () => void
}

export const CalendarActions: FC<CalendarActionsProps> = ({
    sendCalendar,
    saveCalendar,
    clearCalendar,
    deleteCalendar
}) => {
    // отключаем возможность редактирования утвержденных календарей
    // const isSuperAdmin = checkSuperAdminRole()
    const isSuperAdmin = false

    const sendContent = useMemo(
        () => (
            <>
                {isSuperAdmin ? (
                    <span>Календарь будет отправлен на повторное утверждение</span>
                ) : (
                    <span>
                        Календарь будет отправлен на утверждение. После утверждения календаря
                        внесение корректировок будет невозможно
                    </span>
                )}
            </>
        ),
        [isSuperAdmin]
    )

    const saveTitle = useMemo(
        () => (
            <>{isSuperAdmin ? <span>Сохранить календарь</span> : <span>Сохранить черновик</span>}</>
        ),
        [isSuperAdmin]
    )

    const saveContent = useMemo(
        () => (
            <>
                {isSuperAdmin ? (
                    <span>Календарь будет сохранен</span>
                ) : (
                    <span>
                        Календарь будет сохранен как черновик. Редактировать черновик можно в меню
                        «Мои календари»
                    </span>
                )}
            </>
        ),
        [isSuperAdmin]
    )

    const clearContent = useMemo(
        () => <span>Все значения текущего календаря будут очищены</span>,
        []
    )

    const deleteContent = useMemo(
        () => <span>Календарь и все внесенные изменения будут удалены</span>,
        []
    )

    return (
        <div className="calendar-actions">
            <Popover
                title="Утвердить календарь"
                content={sendContent}
                overlayClassName="calendars-action-popover"
            >
                <SendOutlined onClick={sendCalendar} className="calendar-action-icon" />
            </Popover>
            <Popover
                title={saveTitle}
                content={saveContent}
                overlayClassName="calendars-action-popover"
            >
                <SaveOutlined onClick={saveCalendar} className="calendar-action-icon" />
            </Popover>
            <Popover
                title="Очистить календарь"
                content={clearContent}
                overlayClassName="calendars-action-popover"
            >
                <BiEraser onClick={clearCalendar} className="calendar-action-icon eraser" />
            </Popover>
            <Popover
                title="Удалить календарь"
                content={deleteContent}
                overlayClassName="calendars-action-popover"
            >
                <DeleteOutlined onClick={deleteCalendar} className="calendar-action-icon" />
            </Popover>
        </div>
    )
}
